var api = require("!../../../../webpack/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../webpack/node_modules/css-loader/dist/cjs.js??ref--4-1!../../../../webpack/node_modules/postcss-loader/src/index.js??ref--4-2!./app.config.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);

var exported = content.locals ? content.locals : {};



module.exports = exported;